module.exports = __webpack_public_path__ + "img/1-Integras-Splash-Page-MVP.5664e43f.png";